import React from "react"
import Layout from "../Components/Layout"
import MiskaiPhoto from "../assets/images/naujiena-miskai-apdovanojimai.jpg"

export default () => (
  <Layout>
    <div style={{ maxWidth: "860px", margin: "0 auto", padding: "48px 0" }}>
      <h2>Šiemet nacionaliniame aplinkosaugos egzamine – dėmesys miškų temai</h2>

      <img
        src={MiskaiPhoto}
        alt="Nacionalinio aplinkosaugos egzamino apdovanojimų renginys"
        style={{ width: "100%", borderRadius: "8px", margin: "24px 0" }}
      />

      <div className="text-container" style={{ textAlign: "left" }}>
        <p>
          Žaliosios politikos institutas kviečia Tarptautinės klimato dienos
          išvakarėse – spalio 23 dieną – pasitikrinti savo žinias
          tradiciniame aplinkosaugos egzamine. Šis egzaminas – jau penktą
          kartą organizuojamas vyresnių klasių moksleivių, ekspertų ir visos
          visuomenės žinių patikrinimas. Praėjusiais metais egzaminą sprendė
          beveik 10 tūkst. žmonių ir jiems pavyko šiek tiek kilstelti
          ankstesniųjų metų egzamino dalyvių balų vidurkį – nuo 5 (pirmųjų
          egzaminų rezultato) iki 6. Tačiau akivaizdu, kad dar yra erdvės
          parodyti, jog ne tik mylime gamtą, bet ir turime žinių, kaip ją
          apsaugoti.
        </p>

        <p>
          Organizatoriai atkreipia dėmesį, jog šiemet Nacionalinis
          aplinkosaugos egzaminas organizuojamas naujoje platformoje:{" "}
          <a href="https://www.aplinkosaugosegzaminas.lt" target="_blank" rel="noopener noreferrer">
            www.aplinkosaugosegzaminas.lt
          </a>
          . Čia jau dabar galite užsiregistruoti ir spalio 23 – dieną nuo 8
          iki 20 val. užsukti atsakyti į 20 klausimų apie atliekų tvarkymą,
          energetiką, biologinę įvairovę, žiedinę ekonomiką, atliekų
          tvarkymą, klimato kaitą ir miškus.
        </p>

        <p>
          Egzamino dalyviai renkasi savo kategoriją iš 4 galimų:
          pradedančiojo (7–9 klasių moksleiviams), smalsuolio (10–12 klasių
          moksleiviams), tyrinėtojo (visuomenei) ir eksperto (specialistams,
          dirbantiems aplinkosaugos srityje).
        </p>

        <p>
          Šiemet kiekvienos amžiaus ir žinių kategorijos dalyviai egzamine
          ras egzamino partnerio – Valstybinių miškų urėdijos – specialistų
          paruoštą klausimą apie miškų išsaugojimo veiklas ar miško gyvūnus.
        </p>

        <p>
          „Atsakingas požiūris į mišką prasideda nuo žinių. Kuo geriau
          visuomenė supranta miške vykstančius procesus – nuo naujos miško
          kartos auginimo iki biologinės įvairovės ir buveinių apsaugos – tuo
          lengviau suvokti ir miškininkų priimamų sprendimų reikšmę.
          Nacionalinis aplinkosaugos egzaminas yra gera galimybė ne tik
          pasitikrinti žinias, bet ir paskatinti domėjimąsi tuo, kaip
          saugomi, prižiūrimi ir ateities kartoms auginami Lietuvos miškai“,
          – sako VMU generalinis direktorius Valdas Kaubrė.
        </p>

        <h4>Geriausiųjų laukia prizai – pernai nė vienos klaidos nepadarė 16 dalyvių</h4>

        <p>
          Pakuočių atliekų tvarkymo bei perdirbimo klausimai taip pat išlieka
          aktualia aplinkosaugos egzamino dalimi. Ilgamečio egzamino
          pagrindinio rėmėjo, pakuočių atliekų tvarkymo organizacijos
          „Žaliasis taškas“ atstovai sako, kad visuomenei vis dar trūksta
          supratimo, jog pakuočių atliekas privaloma surinkti atskirai ir
          kaip jas atskirti nuo kitų atliekų tipų.
        </p>

        <p>
          „Painiavos įneša tai, jog rūšiavimo taisyklės vis dar skiriasi
          priklausomai nuo savivaldybės. Šiame egzamine moksleiviams ir
          visuomenei norime priminti, kad stiklo, popieriaus ir plastiko
          rūšiavimo konteineriai yra skirti būtent šių tipų pakuočių
          atliekoms. Bus klausimų, kurie patikrins, ar mokame atskirti
          būtent pakuotes,“ – sako organizacijos vadovas Almontas Kybartas.
        </p>

        <p>
          Praėjusiais metais vidutinis egzaminą laikiusių asmenų amžius buvo
          18,5 metų, daugiausia jį sprendė 7–9 klasių kategorijos
          moksleiviai. Egzaminą laikė apie 1000 daugiau merginų ir moterų,
          nei vaikinų ir vyrų, dalyviai registravosi iš įvairiausių Lietuvos
          miestų ir miestelių. 16 dalyvių spręsdami aplinkosaugos egzaminą
          nepadarė nė vienos klaidos ir jį išlaikė absoliučiam 10-tukui.
        </p>

        <p>
          „Egzaminą organizuojame jau penktus metus ir džiaugiamės, kad
          aplinkosauginių žinių balo vidurkis po truputį kyla. Kviečiame
          domėtis ir pažinti savo aplinką, aplinkai palankų gyvenimo būdą –
          tuomet geriau žinosime, kaip tą aplinką saugoti. O geriausiųjų,
          kaip visada – laukia tikrai vertingi prizai!“ – sako Žaliosios
          politikos instituto direktorius Remigijus Lapinskas.
        </p>

        <p>
          Po egzamino visi jį laikę sužino teisingą kiekvieno klausimo
          atsakymą ir paaiškinimą bei šaltinio nuorodą. Tuos, kuriems
          šiemet pavyks surinkti didžiausią balų skaičių, organizatoriai
          lapkričio 20 d. apdovanos vertingais prizais Valstybinėje saugomų
          teritorijų tarnyboje organizuojamame renginyje.
        </p>
      </div>
    </div>
  </Layout>
)
